export default __webpack_public_path__ + "static/media/Group 6314.af6dba87.svg";